exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.voucher-iframe[data-v-e7fbb132] {\n    min-height:1250px;\n}\n", ""]);

// exports
